import PropTypes from 'prop-types'
import { Button, Modal } from 'antd'
import React from 'react'
import { createUseStyles } from 'react-jss'
import { useHistory } from 'react-router-dom'

const useStyles = createUseStyles({
  buttons: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
  },
})

export default function TransmissionModal({ visible, onCancel, onConfirm }) {
  const classes = useStyles()
  const history = useHistory()

  const handleGoToIndex = () => {
    history.push('/unreviewed-reports')
    onCancel()
  }

  return (
    <Modal
      title="Newer Transmission Found"
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <p>
        A newer transmission has been submitted. Do you want to open it now?
      </p>

      <div className={classes.buttons}>
        <Button type="primary" onClick={onConfirm}>
          Yes
        </Button>
        <Button onClick={handleGoToIndex}>No, go back to index</Button>
      </div>
    </Modal>
  )
}

TransmissionModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

TransmissionModal.defaultProps = {
  visible: false,
}
